import { useState } from 'react'
import Modal from '../Modal'
import { Container } from './styles'
import { GrFormClose } from 'react-icons/gr'
import { useAsyncFn } from 'react-use'
import { useSWRConfig } from 'swr'
import { toast } from 'react-toastify'
import { TQuestionBook } from 'pages/Questions/components/QuestionsContent/types'
import Loader from 'components/Loader'
import { RENAME_QUESTION_BOOK } from 'pages/MyQuestionBooks/services'

interface IProps {
  questionBook: TQuestionBook
  isOpen: boolean
  onClose(): void
}

const RenameModal = (props: IProps) => {
  const [text, setText] = useState('')
  const { mutate } = useSWRConfig()

  const updateBooks = () => {
    mutate('/question/books', (prevState) => {
      const newState = [...prevState]
      const index = newState.findIndex((item) => item._id === props.questionBook._id)

      newState[index].name = text
      newState[index].updatedAt = new Date().toISOString()

      return newState
    })
  }

  const [state, execute] = useAsyncFn(async () => {
    try {
      await RENAME_QUESTION_BOOK(props.questionBook._id, text)

      updateBooks()

      toast.success('Caderno renomeado com sucesso!')
    } catch {
      toast.error('Erro ao renomear caderno')
    }
  }, [text])

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <Container>
        <button className="close" onClick={props.onClose}>
          <GrFormClose size="100%" />
        </button>

        <p className="title">Renomear caderno</p>

        <p className="description">Digite um novo título para o caderno</p>

        <div className="input-group">
          <input
            type="text"
            className="text-input"
            placeholder="Nome do caderno"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <button
            className="save"
            disabled={text.length === 0 || state.loading}
            data-loading={state.loading}
            onClick={execute}
          >
            {state.loading ? <Loader className="loader" /> : 'Salvar'}
          </button>
        </div>

        <p className="current-name">
          Nome atual: <b>{props.questionBook.name}</b>
        </p>
      </Container>
    </Modal>
  )
}

export default RenameModal
